<div class="flex flex-col gap-4">
  @switch (currentView()) {
    @case (1) {
      <app-deploy-system-of-ia-step-1
        [existingData]="newDeployment()"
        (stepCompleted)="onStep1Completed($event)" />
    }
    @case (2) {
      <app-deploy-system-of-ia-step-2
        [existingData]="newDeployment()"
        (stepCompleted)="onStep2Completed($event)"
        (goToPreviousStep)="goToPreviousStepFromStep2($event)" />
    }
    @case (3) {
      <app-deploy-system-of-ia-step-3
        [existingData]="newDeployment()"
        (stepCompleted)="onStep3Completed($event)"
        (goToPreviousStep)="goToPreviousStepFromStep3($event)" />
    }
    @case (4) {
      <app-deploy-system-of-ia-step-4
        [existingData]="newDeployment()"
        (stepCompleted)="onStep4Completed($event)"
        (goToPreviousStep)="goToPreviousStepFromStep4($event)" />
    }
    @case (5) {
      <app-deploy-system-of-ia-step-5
        [existingData]="newDeployment()"
        (stepCompleted)="onStep5Completed($event)"
        (goToPreviousStep)="goToPreviousStepFromStep5($event)" />
    }
    @case (6) {
      <app-deploy-system-of-ia-step-6
        [existingData]="newDeployment()"
        (stepCompleted)="onStep6Completed($event)"
        (goToPreviousStep)="goToPreviousStepFromStep6($event)" />
    }
  }
  <p-confirmdialog />
</div>
